/* import __COLOCATED_TEMPLATE__ from './status-pill.hbs'; */
import Component from '@glimmer/component';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    color: 'green' | 'red' | 'yellow' | 'gray';
  };
  Blocks: {
    default: [];
  };
}

export default class StatusPill extends Component<Signature> {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Settings::BillingPage::StatusPill': typeof StatusPill;
  }
}
